import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import loaderimage from "../../../images/giphy.gif";
import ConfirmationModal from "../../shared/ConfirmationModal";
import NewconfirmationModal from "../../shared/NewconfirmationModal";
import AllFailureModal from "../../shared/AllFailureModal";

interface Degree {
  d_id: number;
  degree_name: string;

}
const DegreeList = () => {
  const [degrees, setDegrees] = useState([]);
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [actionType, setActionType] = useState("");
  const [selectedDegreeID, setSelectedDegreeID]  = useState(0);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failureMessage, setFailureMessage] = useState('');
  const [filtereddegree, setFiltereddegree] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const headers = {
    "x-access-token": localStorage.getItem("jwttoken") || "",
  };


  const apiCalldegrees = async () => {
    try {
      setLoader(true);
      setError("");
      const url = process.env.REACT_APP_API_URL + "degree/alldegrees";
      const response = await axios.get(url,{headers});
      console.log(response)
      setDegrees(response.data.data);
      setFiltereddegree(response.data.data);
    } catch (error) {
      setError("Not Found!!!");
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    apiCalldegrees();
  }, []);

  const handleAction = async () => {
    if (!selectedDegreeID) return;

    try {
      let url = "";
      if (actionType === "Delete") {
        url = `${process.env.REACT_APP_API_URL}degree/removedegree/${selectedDegreeID}`;
        await axios.delete(url, { headers });
        setSuccessMessage("degree deleted successfully.");
      }

      apiCalldegrees();
      setShowSuccessModal(true);
    } catch (error) {
      setFailureMessage("Failed to delete degree . Please try again.");
      setShowFailureModal(true);
    }
  };

  const triggerActionModal = (action:any, degreeId:number) => {
    setSelectedDegreeID(degreeId);
    setActionType(action);
    if (action === "Delete") {
      setModalMessage("Are you sure you want to delete this degree?");
    }
    setShowModal(true);
  };
const handleSearch = (e:any) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
  };
  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      if (searchTerm === "") {
        setFiltereddegree(degrees);
      } else {
        const filtered = degrees.filter(
          (degree:any) =>
            degree?.d_id?.toString().toLowerCase().includes(searchTerm) ||
            degree?.degree_name?.toLowerCase().includes(searchTerm)
        );
        setFiltereddegree(filtered);
      }
    }, 300);
    return () => clearTimeout(debounceTimeout);
  }, [searchTerm, degrees]);


  return (
    <>
      <div className="">
        <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="text-black fw-bold">Degree Management</h2>
        <div className="d-flex gap-2 align-items-center  w-50">
            <span className="fw-bold text-secondary text-nowrap">{filtereddegree.length} results</span>
            <input
              type="text"
              className="form-control"
              placeholder="Search by degree Id or degree Name"
              value={searchTerm}
              onChange={handleSearch}
            />
          <Link to="/degreeadd" className="btn bg-info">+ Add New Degree</Link>
        </div>
      </div>
      <div className="card shadow-sm border-0 rounded">
        <div className="card-header bg-info text-white">
          <h5 className="mb-0 text-white">Degree List</h5>
        </div>
          <div className="card-body p-0">
            <div className="table-responsive sticky-table-container">
              <table className="table table-hover align-middle mb-0">
                <thead className="table-light position-sticky top-0" >
            <tr>
              <th>Sr No</th>
              <th>Degree ID</th>
              <th>Degree Name</th>
              <th className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
          {loader ? (
                   <tr>
                   <td colSpan={10} className="text-center py-2">
                     <img src={loaderimage} alt="Loading..." height="40" />
                   </td>
                 </tr>
                  ) : error ? (
                    <tr>
                      <td colSpan={10} className="text-center text-danger fw-bold py-3">
                      <div className="alert alert-danger text-center m-3" role="alert">
            Oops! Something went wrong. Please try again later.
          </div>
                      </td>
                    </tr>
                  ) : filtereddegree.length > 0 ? (
                  filtereddegree.map((item:any, index) => (
                  <tr key={item.d_id} className="border-bottom">
                    <td>{index + 1}</td>
                    <td>{item.d_id}</td>
                    <td>{item.degree_name}</td>
                    <td className="text-center">
                    <div className="d-flex justify-content-center gap-2">
                      <Link
                        to={`/degree/edit/${item.d_id}`}
                        className="btn btn-sm btn-outline-warning"
                      >
                        Edit
                      </Link>
                      <button
                        onClick={() =>
                          triggerActionModal("Delete", item.d_id)
                        }
                        className="btn btn-sm btn-outline-secondary" 
                      >
                        Delete
                      </button>
                      </div>
                    </td>
                   
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={10} className="text-center  text-muted fw-bold">
                  <div className="alert alert-secondary text-center m-3" role="alert">
                  No degrees available
                </div>
                  </td>
                </tr>
              )}
                </tbody>
              </table>
            </div>
        </div>
        </div>

        {/* Confirmation Modal for Actions */}
        <ConfirmationModal
          show={showModal}
          onHide={() => setShowModal(false)}
          modalMessage={modalMessage}
          confirmation={handleAction}
          operationType={actionType}
        />

        {/* Success Confirmation Modal */}
        <NewconfirmationModal
          show={showSuccessModal}
          onHide={() => setShowSuccessModal(false)}
          modalMessage={successMessage}
          operationType="OK"
          timeoutDuration={3000}
        />
        <AllFailureModal 
        show={showFailureModal} 
        onHide={() => setShowFailureModal(false)} 
        modalMessage={failureMessage}  
        operationType="OK" 
        timeoutDuration={3000}/>
      </div>
    </>
  );
};

export default DegreeList;
